import { createAction } from '@reduxjs/toolkit';
import { addSeconds } from 'date-fns';
import EcomEngineAPI from 'api/ecom_engine_api';

export const setBooking = createAction('resources/setBooking');
export const updateBooking = createAction('resources/updateBooking');

export const touchBooking = (bookingId) => (dispatch) =>
  EcomEngineAPI.booking.touch(bookingId).then((booking) => {
    if (booking.ttlseconds !== undefined) {
      // AS-9331
      // Booking#show?touch=true does not return updated values.
      // this is a temporary work around until the AS ticket is resolved and deployed
      // TODO: C3W-834 Remove workaround
      const now = new Date();
      booking.updated_at = now.toISOString();

      if (booking.ttlseconds) {
        booking.expires_from = addSeconds(
          now,
          booking.ttlseconds
        ).toISOString();
      }
    }

    dispatch(updateBooking(booking));
  });

export const updateBookingWithNestedAttributes = (params) => () =>
  EcomEngineAPI.booking.updateBookingWithNestedAttributes(params);
